export default {
  sm: '3px',
  md: '5px',
  full: '9999px',
} as const
